import { type CommunityInvitationToken, createCommunityInvitationToken } from 'models';
import { useMutation } from 'query';
import { getInvitationToken } from '../../services';

export const useGetInvitationTokenMutation = () =>
  useMutation<CommunityInvitationToken, { communityId: string }>({
    async mutationFn({ communityId }) {
      const response = await getInvitationToken({ routeParams: { id: communityId } });
      return createCommunityInvitationToken(response.data);
    },
  });
